export type AuthPurpose = 'login' | 'register' | 'link' | 'reauthenticate';
export type SignInIdentity = { id: number; provider: string; display: string; can_disconnect: boolean };
export type IdentitySettings = { identities: SignInIdentity[]; providers: string[]; reauthentication_required: boolean; linking_enabled: boolean };
export type AuthFlowStart = { flow_token?: string; redirect_url?: string; sent?: boolean; purpose: AuthPurpose; provider?: string };

export class IdentityOperationError extends Error {
  constructor(public reason: string, public status: number) { super(reason); }
}

/** Auth operations stay app-owned. Errors never clear the current profile or cart. */
export async function identityRequest<T>(backend: string, endpoint: string, method = 'GET', body?: Record<string, unknown>): Promise<T> {
  const response = await fetch(`${backend}${endpoint}`, {
    method, credentials: 'include', cache: 'no-store',
    headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': 'true' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const payload = await response.json() as T & { reason?: string };
  if (!response.ok) throw new IdentityOperationError(payload.reason ?? 'authentication_failed', response.status);
  return payload;
}

export function authReturnUrl(): string {
  const url = new URL(window.location.href);
  url.searchParams.delete('auth_token'); url.searchParams.delete('magic_token');
  return url.toString();
}
